import { render, staticRenderFns } from "./ResendContainer.vue?vue&type=template&id=3842bac9&scoped=true"
import script from "./ResendContainer.vue?vue&type=script&lang=js"
export * from "./ResendContainer.vue?vue&type=script&lang=js"
import style0 from "./ResendContainer.vue?vue&type=style&index=0&id=3842bac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842bac9",
  null
  
)

export default component.exports